import React from "react";

export interface TodayTimeSlotProps {
  hour: number;
  services?: any[];
  handlers: {
    onServiceClick: (service: any) => void;
    onEmptySlotClick?: (time: string) => void;
    onAssignEmployee?: (booking: any) => void;
    onReschedule?: (booking: any) => void;
    onUpdateDuration?: (booking: any) => void;
  };
}

const TodayTimeSlot: React.FC<TodayTimeSlotProps> = ({
  hour,
  handlers,
}) => {
  const slotTime24 = `${hour < 10 ? "0" : ""}${hour}:00`;
  const formattedHourLabel = hour > 12 ? `${hour - 12}:00 PM` : `${hour}:00 AM`;

  return (
    <div className="flex border-b border-slate-100 last:border-b-0 h-[80px]">
      {/* Time Label */}
      <div className="w-28 p-4 border-r border-slate-100 text-sm font-bold text-slate-600 bg-slate-50/50 flex items-center justify-center shrink-0 select-none">
        {formattedHourLabel}
      </div>

      {/* Available Slot Interactive Row */}
      <div
        onClick={() => handlers.onEmptySlotClick?.(slotTime24)}
        className="flex-1 p-3 flex items-center text-xs text-slate-400 font-medium hover:text-yellow-600 transition-colors cursor-pointer hover:bg-slate-50/50"
      >
        + Available Slot (Click to book)
      </div>
    </div>
  );
};

export default TodayTimeSlot;